var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contentDiv"},[_c('div',{staticClass:"infoDiv"},[_c('div',{staticClass:"infoValue"},[_vm._v(_vm._s(_vm.info))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }